import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react"
import { cn } from "../../lib/cn"
import type { ButtonVariant } from "./Button"

const variantClasses: Record<ButtonVariant, string> = {
  primary: "bg-accent text-text-on-accent hover:opacity-90",
  secondary: "border border-border-strong bg-surface text-text-primary hover:bg-surface-muted",
  destructive: "bg-danger text-white hover:opacity-90",
  ghost: "text-text-secondary hover:bg-surface-muted hover:text-text-primary",
}

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  label: string
  icon: ReactNode
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { variant = "ghost", label, icon, className, disabled, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      aria-label={label}
      title={label}
      disabled={disabled}
      className={cn(
        "inline-flex size-9 shrink-0 items-center justify-center rounded-button transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 disabled:opacity-50",
        variantClasses[variant],
        className,
      )}
      {...props}
    >
      {icon}
    </button>
  )
})
